// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var ListEmailMessagesRequest_Category;
(function (ListEmailMessagesRequest_Category) {
    ListEmailMessagesRequest_Category["CATEGORY_ALL"] = "CATEGORY_ALL";
    ListEmailMessagesRequest_Category["CATEGORY_DELIVERED"] = "CATEGORY_DELIVERED";
    ListEmailMessagesRequest_Category["CATEGORY_FAILED"] = "CATEGORY_FAILED";
    ListEmailMessagesRequest_Category["CATEGORY_ENGAGED"] = "CATEGORY_ENGAGED";
    ListEmailMessagesRequest_Category["CATEGORY_UNSUBSCRIBED"] = "CATEGORY_UNSUBSCRIBED";
})(ListEmailMessagesRequest_Category || (ListEmailMessagesRequest_Category = {}));
export var ListEmailMessagesRequest_Category_index;
(function (ListEmailMessagesRequest_Category_index) {
    ListEmailMessagesRequest_Category_index[ListEmailMessagesRequest_Category_index["CATEGORY_ALL"] = 0] = "CATEGORY_ALL";
    ListEmailMessagesRequest_Category_index[ListEmailMessagesRequest_Category_index["CATEGORY_DELIVERED"] = 1] = "CATEGORY_DELIVERED";
    ListEmailMessagesRequest_Category_index[ListEmailMessagesRequest_Category_index["CATEGORY_FAILED"] = 2] = "CATEGORY_FAILED";
    ListEmailMessagesRequest_Category_index[ListEmailMessagesRequest_Category_index["CATEGORY_ENGAGED"] = 3] = "CATEGORY_ENGAGED";
    ListEmailMessagesRequest_Category_index[ListEmailMessagesRequest_Category_index["CATEGORY_UNSUBSCRIBED"] = 4] = "CATEGORY_UNSUBSCRIBED";
})(ListEmailMessagesRequest_Category_index || (ListEmailMessagesRequest_Category_index = {}));
export const EmailCampaignService = {
    // CreateEmailCampaign creates a new campaign of emails. This endpoint will validate the input and
    // check that the campaign will not cause the location to exceed the quota. A process will be started
    // to schedule messages.
    CreateEmailCampaign(fn, req) {
        return fn(`/messaging/bulk/email-campaign/v1/campaigns`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // UpdateEmailCampaign updates the email campaign. This can be done before or after sending starts.
    // However, after send starts only the campaign title can be updated.
    UpdateEmailCampaign(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // CancelEmailCampaign cancels the email campaign messages. This can be done only before sending starts.
    CancelEmailCampaign(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}/cancel`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    // DeleteEmailCampaign deletes the email campaign. This is only a soft delete. If there are emails that are not yet sent
    // then those emails get canceled. Deleted email campaigns should not be sent in GetEmailCampaigns.
    DeleteEmailCampaign(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "DELETE" });
    },
    // GetEmailCampaign gets a single campaign.
    GetEmailCampaign(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "GET" });
    },
    // ListEmailCampaigns gets a list of email campaigns that are not drafts. The result will be split up by month provided in the date range.
    ListEmailCampaigns(fn, req) {
        return fn(`/messaging/bulk/email-campaign/v1/campaigns?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListEmailDrafts gets a list of email draft campaigns. The result will be all drafts created in the request year.
    ListEmailDrafts(fn, req) {
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/drafts?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListEmailMessages returns list of messages associated with a campaign. With campaigns having up to 110,000
    // recipients, this endpoint is paginated. There are also categories of messages that the response can be filtered by.
    ListEmailMessages(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}/messages?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "GET" });
    },
    // GetActiveYears will return all the years that a location has been active with email marketing.
    // Including the current and next year in the future. For example, if the current year is 2026, and
    // the location sent email campaigns in 2023, 2024, and 2026, the years returned would be
    // 2023, 2024, 2026, and 2027.
    // This helps to generate the dropdown for the UI of which years to show email marketing for.
    GetActiveYears(fn, req) {
        return fn(`/messaging/bulk/email-campaign/v1/years?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // CreateContactList creates a list of contacts for bulk messaging that are treated as recipients.
    // Required fields are: Title, location id, weave user id, and at least 1 contact.
    // Contacts need to have a: first name, last name, and phone number.
    CreateContactList(fn, req) {
        return fn(`/messaging/bulk/email-campaign/v1/lists`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // UpdateContactList updates a list of contacts for bulk messaging.
    // The title or contacts can be updated.
    UpdateContactList(fn, req) {
        try {
            fm.validateUrlParam(req["listId"], "listId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/lists/${req["listId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // DeleteContactList will hard delete the list and the contacts associated with the list.
    DeleteContactList(fn, req) {
        try {
            fm.validateUrlParam(req["listId"], "listId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/lists/${req["listId"]}?${fm.renderURLSearchParams(req, ["listId"])}`, { method: "DELETE" });
    },
    // GetContactList retrieves the list information and the contacts associated with the list.
    GetContactList(fn, req) {
        try {
            fm.validateUrlParam(req["listId"], "listId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/lists/${req["listId"]}?${fm.renderURLSearchParams(req, ["listId"])}`, { method: "GET" });
    },
    // ListContactLists returns a list of all the contact lists for a location.
    // The response to this endpoint will only contain the contact count, not every contact.
    // If all contacts are needed, then call the GetContactList endpoint.
    ListContactLists(fn, req) {
        return fn(`/messaging/bulk/email-campaign/v1/lists?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // AddToAudience adds recipients to a hidden draft campaign. The reason this is done is so
    // an accurate count of recipients can be retrieved with all the different filter options for an audience.
    AddToAudience(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}/audience`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // RemoveAudience removes the recipients already retrieved for the hidden draft campaign.
    // For example if a location has 3 filters selected on a campaign, and would like to change a
    // filter they would need to start over with an empty slate of recipients. This is to clear recipients.
    RemoveAudience(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}/audience?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "DELETE" });
    },
    // GetAudience returns the recipent counts for a campaign broken out by location and also rolled up in a total.
    GetAudience(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}/audience?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "GET" });
    },
    // LimitAudience limits the number of recipients for a campaign by location.
    LimitAudience(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}/audience:limit`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // Sends a test email (defined on the request) to the email addresses provided. Can only be called via http.
    SendTestEmail(fn, req) {
        return fn(`/messaging/bulk/email-campaign/v1/test`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ListUsageAndAllotment lists the usage and allotment for the year broken down by month for given location ids.
    ListUsageAndAllotment(fn, req) {
        return fn(`/messaging/bulk/email-campaign/v1/usage?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetSegments lists the segments for a campaign
    GetSegments(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}/segments?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "GET" });
    },
    // GetSegments lists the segments for a campaign
    DeleteSegment(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
            fm.validateUrlParam(req["segmentId"], "segmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-campaign/v1/campaigns/${req["campaignId"]}/segments/${req["segmentId"]}?${fm.renderURLSearchParams(req, ["campaignId", "segmentId"])}`, { method: "DELETE" });
    },
};
